import React from 'react'

export const OnBoardingContentImage = ({ src }) => {
  return (
    <div className="mb-3 shadow">
      <img src={src} className="img-fluid" alt={`Help  ${src}`} />
    </div>
  )
}
